import type { CurrencyInterface, PaymentTypeInterface } from '@/types'
import api from '@/utils/api/api'

type RequestOptions = {
  signal?: AbortSignal
}

type PaymentTypesResponse = { paymentTypes: PaymentTypeInterface[] }

type CurrenciesResponse = { currencies: CurrencyInterface[] }

export const dictionariesApi = {
  getPaymentTypes: async (options?: RequestOptions) => {
    const { data } = await api.get<PaymentTypesResponse>('/payment-types/all', {
      signal: options?.signal,
    })
    return data.paymentTypes
  },
  getCurrencies: async (options?: RequestOptions) => {
    const { data } = await api.get<CurrenciesResponse>('/currencies/all', {
      signal: options?.signal,
    })
    return data.currencies
  },
}
